import { configureStore } from '@reduxjs/toolkit';
import {
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import type { Dictionary } from 'lodash';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { setupListeners } from '@reduxjs/toolkit/query';

import rootReducer from 'reducers';
import { rehydrate } from 'actions/formActions';
import { routerMiddleware, createReduxHistory } from 'store/reduxFirstHistory';
import backendApi from 'slices/backendApi';

export const store = configureStore({
  reducer: rootReducer,
  // enhancers: [reduxReset()],
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // Customize the built-in serializability dev check
      serializableCheck: {
        ignoredActions: [
          FLUSH,
          REHYDRATE,
          PAUSE,
          PERSIST,
          PURGE,
          REGISTER,
          'backendApi/executeMutation/fulfilled',
        ],
        // ignoredActionPaths: [`${CALL_API}.reauthorizeWith`],
      },
    }).concat(routerMiddleware, backendApi.middleware),
});

// Expose store when run in Cypress.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
if ((window as Dictionary<any>).Cypress) {
  // console.log('configureStore: storing store', store);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as Dictionary<any>).store = store;
}

export const persistor = persistStore(store, {}, () => {
  store.dispatch(rehydrate());
});

setupListeners(store.dispatch);

export const history = createReduxHistory(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
